import React from 'react';
import Relay from 'react-relay';

import { Card, CardTitle, CardText } from 'react-mdl/lib/Card';

import MailingListMembers from './MailingListMembers/MailingListMembers';
import loader from '../../loader';

let _MailingListDetails = Relay.createContainer(class extends React.Component {
    componentWillMount() {
        this.setState({
            loading: false,
        })
    }

    render() {
        if (this.state.loading) {
            return loader();
        }

        let list = this.props.mailingList;

        return (
            <div>
                <Card shadow={0} style={{width: '512px', margin: '2em auto'}}>
                    <CardTitle style={{backgroundColor: '#3E4EB8', color: '#FFFFFF'}}>Mailing List "{list.name}"</CardTitle>
                    <CardText>
                        {list.address}
                    </CardText>
                    <CardText>
                        {list.description}
                    </CardText>
                    <CardText>
                        {list.access_level}
                    </CardText>
                </Card>
                <MailingListMembers list={list} reload={() => {
                    this.props.relay.forceFetch(null, state => {
                        if (state.ready) {
                            this.setState({loading: state.stale});
                        }
                    });
                }}/>
            </div>
        );
    }
}, {
    fragments: {
        mailingList: () => Relay.QL`
            fragment on MailingList {
                access_level
                address
                description
                members_count
                name
                
                ${MailingListMembers.getFragment('list')}
            }
        `,
    }
});

export default class MailingListDetails extends React.Component {
    componentWillMount() {
        this.setState({
            route: {
                queries: {
                    mailingList: () => Relay.QL`
                        query { mailingList(address: $address) }
                    `,
                },
                params: {
                    address: this.props.params.address,
                },
                // Routes must also define a string name.
                name: 'MailingListRoute',
            }
        })
    }

    render() {
        return (
            <Relay.RootContainer
                Component={_MailingListDetails}
                route={this.state.route}
                renderLoading={loader}
            />
        );
    }
};


/** WEBPACK FOOTER **
 ** ./src/Routes/MailingListDetails/MailingListDetails.js
 **/